import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Patch } from "../Axios/AxiosFunctions";
import { apiHeader, URL } from "../Config/apiUrl";
import { saveLoginUserData } from "../store/Actions/authAction";

const ChangePasswordScreeb = ({ setfooterStyle }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const token = useSelector((state) => state?.authReducer?.access_token);
  console.log(token);

  const [input, setInput] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  //   handleChange
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };

  //   handleSubmit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // validate
    for (let key in input) {
      if (input[key].trim() == "") {
        return toast.warn(
          `${key.replace(/([a-z])([A-Z])/g, "$1 $2")} can not be empty.`
        );
      }
    }

    if (input?.newPassword.trim() !== input?.confirmNewPassword.trim()) {
      return toast.warn("Password did not match.");
    }

    const params = {
      passwordCurrent: input?.currentPassword.trim(),
      password: input?.newPassword.trim(),
      passwordConfirm: input?.confirmNewPassword.trim(),
    };
    const url = URL("general/updateMyPassword");
    setIsSubmittingForm(true);
    const response = await Patch(url, params, apiHeader(token));
    setIsSubmittingForm(false);

    if (response !== undefined) {
      setInput({
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      });
      dispatch(saveLoginUserData(response?.data?.data));
      toast.success("Password changed successfully.");
    }
  };

  return (
    <div>
      <Container className="contactForm_main change_password">
        <Row>
          <Col>
            <div className="contact_form_width">
              <div className="contact_form_innerWidth">
                <Row>
                  <Col className="text-center mb-3">
                    <h4 className="contact_form_heading ">Change Password</h4>
                  </Col>
                </Row>
                <form onSubmit={handleSubmit}>
                  <Row className="form_row mt-5">
                    {/* currentPassword */}
                    <Col md={12} className="mb-4">
                      <Form.Control
                        type="password"
                        placeholder="Current Password"
                        name="currentPassword"
                        value={input.currentPassword}
                        required
                        onChange={handleChange}
                      />
                    </Col>
                    <Col md={12} className="mb-4">
                      <Form.Control
                        type="password"
                        placeholder="New Password"
                        name="newPassword"
                        value={input.newPassword}
                        required
                        onChange={handleChange}
                      />
                    </Col>
                    <Col md={12} className="mb-4">
                      <Form.Control
                        type="password"
                        placeholder="Confirm New Password"
                        name="confirmNewPassword"
                        value={input.confirmNewPassword}
                        required
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="text-center">
                        <Button disabled={isSubmittingForm} type="submit">
                          {isSubmittingForm ? "Please Wait..." : "Submit"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ChangePasswordScreeb;
